import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Footer from "./Footer";
import HeadingNavbar from "./HeadingNavbar";
import Header from "./Header";
import { Helmet } from "react-helmet";

const CookiePolicy = () => {
  return (
    <>
      <Helmet>
        <title>Cookie Policy | Bliss Water Technology</title>
        <meta
          name="description"
          content="Learn how Bliss Water Technology uses cookies to improve your browsing experience and protect your privacy. View details about cookie usage and how to control preferences."
        />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <HeadingNavbar />
      <Header />

      <Container>
        <Row className="my-md-5 my-4">
          <Col>
            <Card.Title className="text-center fs-2 mb-3 fw-bold">
              Cookie Policy
            </Card.Title>
            <Card>
              <Card.Body>
                <Card.Text as="div">
                  <section>
                    <h5 className="fw-bold">Introduction</h5>
                    <p>
                      At <strong>Bliss Water Technology</strong>, we respect
                      your privacy and are committed to being transparent about
                      how we use cookies and tracking technologies. This Cookie
                      Policy is part of our broader Privacy Policy.
                    </p>
                  </section>

                  <section>
                    <h5 className="fw-bold">What Are Cookies?</h5>
                    <p>
                      Cookies are small text files that are placed on your
                      device when you visit our website. They help us understand
                      your preferences, remember login details, analyze traffic,
                      and improve the overall user experience. Similar
                      technologies include web beacons, tracking scripts, and
                      pixels.
                    </p>
                  </section>

                  <section>
                    <h5 className="fw-bold">Why We Use Cookies</h5>
                    <ul>
                      <li>To manage user sessions and orders</li>
                      <li>
                        To analyze website traffic using tools like Google
                        Analytics
                      </li>
                      <li>To display relevant product recommendations</li>
                      <li>
                        To measure performance of ads from platforms like Meta
                        and Google
                      </li>
                    </ul>
                  </section>

                  <section>
                    <h5 className="fw-bold">Types of Cookies We Use</h5>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Type</th>
                          <th>Purpose</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Essential</td>
                          <td>
                            Required for basic website functionality such as
                            navigation and order processing
                          </td>
                        </tr>
                        <tr>
                          <td>Analytics</td>
                          <td>
                            Help us understand how users interact with our
                            website
                          </td>
                        </tr>
                        <tr>
                          <td>Advertising</td>
                          <td>
                            Used to show relevant ads based on your activity
                            (e.g., Meta, Google Ads)
                          </td>
                        </tr>
                        <tr>
                          <td>Preference</td>
                          <td>
                            Store user-selected preferences like language and
                            location
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </section>

                  <section>
                    <h5 className="fw-bold">Third-Party Cookies</h5>
                    <p className="m-0">
                      We may allow trusted third-party services to place cookies
                      on your device for advertising and analytics. These may
                      include:
                    </p>
                    <ul>
                      <li>Google Analytics</li>
                      <li>Google Ads & Tag Manager</li>
                      <li>Meta Pixel (Facebook Ads)</li>
                    </ul>
                    <p>
                      These services are governed by their own privacy policies.
                    </p>
                  </section>

                  <section>
                    <h5 className="fw-bold">Managing Cookies</h5>
                    <p className="m-0">
                      You can control or disable cookies through your browser
                      settings. Please note that disabling essential cookies may
                      impact website functionality.
                    </p>
                    <ul>
                      <li>
                        <a
                          href="https://support.google.com/chrome/answer/95647"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Google Chrome
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Mozilla Firefox
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://support.apple.com/en-in/guide/safari/sfri11471/mac"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Safari
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://support.microsoft.com/en-us/windows/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Microsoft Edge
                        </a>
                      </li>
                    </ul>
                  </section>

                  <section>
                    <h5 className="fw-bold">Changes to This Policy</h5>
                    <p>
                      We may update this Cookie Policy occasionally. Updates
                      will be posted on this page and will take effect
                      immediately upon publication.
                    </p>
                  </section>

                  <section>
                    <h5 className="fw-bold">Contact Us</h5>
                    <p>
                      If you have questions about our cookie practices, please
                      email us at{" "}
                      <a href="mailto:blisswatertechnology@gmail.com">
                        blisswatertechnology@gmail.com
                      </a>{" "}
                      or call our support team at{" "}
                      <a href="tel:+919265199516">+91 92651 99516</a>.
                    </p>
                  </section>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      <Footer />
    </>
  );
};

export default CookiePolicy;
